module.exports = __webpack_public_path__ + "static/media/icon-dashboard-profile.371455ac.svg";